<div class="flex flex-col gap-5">
    @if (briefAi.isDrafting()) {
    <div aria-busy="true" class="flex flex-col gap-5">
        <bb-ai-thoughts-scroll [thoughts]="briefAi.streamingThoughts()"
            [isCompiling]="briefAi.isCompilingBrief()" />
    </div>
    } @else {

    @if (showMethodChooser()) {
    <div class="flex flex-col gap-3.5">
        <p class="m-0 text-lg font-bold tracking-tight text-foreground">How do you want to define your creative
            direction?</p>
        <ul role="list" class="grid grid-cols-1 gap-3 sm:grid-cols-2">
            @for (m of methods; track m.id) {
            <li>
                <button type="button" (click)="selectMethod(m.id)"
                    [attr.aria-pressed]="service.creativeMethod() === m.id"
                    class="relative flex w-full flex-col items-start gap-1 rounded-lg border p-4 text-left transition-colors"
                    [class]="service.creativeMethod() === m.id ? 'border-brand-studio bg-brand-studio/10' : 'border-border bg-card hover:border-brand-studio/60'">
                    @if (m.tag) {
                    <span
                        class="absolute right-3 top-3 rounded-full bg-brand-studio px-2 py-0.5 text-[10px] font-extrabold tracking-wider text-white">{{
                        m.tag }}</span>
                    }
                    <span class="mb-1 grid size-10 place-items-center rounded-md transition-colors"
                        [class]="service.creativeMethod() === m.id ? 'bg-brand-studio text-white' : 'bg-muted text-muted-foreground'">
                        @switch (m.id) {
                        @case ('upload') {
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 13v8" />
                            <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
                            <path d="m8 17 4-4 4 4" />
                        </svg>
                        }
                        @case ('type') {
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 20h9" />
                            <path d="M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z" />
                        </svg>
                        }
                        @case ('template') {
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect width="18" height="7" x="3" y="3" rx="1" />
                            <rect width="9" height="7" x="3" y="14" rx="1" />
                            <rect width="5" height="7" x="16" y="14" rx="1" />
                        </svg>
                        }
                        @case ('ai') {
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path
                                d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                        </svg>
                        }
                        }
                    </span>
                    <span class="text-base font-bold text-foreground">{{ m.title }}</span>
                    <span class="text-xs leading-relaxed text-muted-foreground">{{ m.desc }}</span>
                </button>
            </li>
            }
        </ul>
    </div>
    <!-- Kept mounted (hidden <dialog>) so the ViewChild resolves before the first "Select Template" click. -->
    <atom-brief-template-drawer #briefTemplateDrawer (templateSelected)="onBriefTemplateApplied($event)"
        (templateCreated)="onBriefTemplateApplied($event)" />
    }

    @if (showMethodChooser() && service.creativeMethod() === 'upload') {
    <div class="flex flex-col gap-3">
        @if (showFileDropzone()) {
        @for (epoch of [fileUploaderEpoch()]; track epoch) {
        <atom-add-document (documentUploaded)="onDocumentUploaded($event)" />
        }
        }
        @if (showFileDropzone() && showGoogleDocField()) {
        <p class="m-0 text-center text-xs font-semibold text-muted-foreground">or</p>
        }
        @if (showGoogleDocField()) {
        <div class="flex flex-col gap-1.5">
            <label for="public-google-doc-link" class="text-sm font-semibold text-foreground">Public Google Doc link</label>
            <input id="public-google-doc-link" type="url" inputmode="url" autocomplete="off"
                [value]="googleDocLink()" (input)="onGoogleDocLinkInput($any($event.target).value)"
                (blur)="onGoogleDocLinkBlur()" placeholder="https://docs.google.com/document/d/…"
                [attr.aria-invalid]="googleDocError() ? true : null"
                [attr.aria-describedby]="googleDocError() ? 'public-google-doc-hint public-google-doc-error' : 'public-google-doc-hint'"
                class="w-full rounded-md border border-border bg-card px-3 py-2 text-sm outline-none focus:border-brand-studio focus:ring-2 focus:ring-brand-studio/25" />
            <p id="public-google-doc-hint" class="m-0 text-xs text-muted-foreground">Share the doc so anyone with the
                link can view it.</p>
            @if (googleDocError()) {
            <p id="public-google-doc-error" role="alert" class="m-0 text-sm text-destructive">{{ googleDocError() }}</p>
            }
            @if (googleDocLink().trim()) {
            <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary self-start shrink-0"
                (click)="clearGoogleDocLink()">Upload a file instead</button>
            }
        </div>
        }
        @if (hasUploadedFile()) {
        <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary self-start shrink-0"
            (click)="clearUploadedDocument()">Remove file</button>
        <p class="m-0 text-xs text-muted-foreground">Remove the uploaded file to add a public Google Doc link instead.</p>
        }
        <p class="m-0 text-xs text-muted-foreground">We store your document with the brief so the team can reference it —
            you can still fill in the details below.</p>
    </div>
    } @else if (showMethodChooser() && service.creativeMethod() === 'template') {
    <div class="flex flex-col gap-3">
        <p class="m-0 text-sm text-muted-foreground">Pick one of your saved templates to pre-fill the creative fields,
            then review and tweak before you continue.</p>
        <button type="button"
            class="inline-flex items-center gap-2 self-start rounded-md border border-border px-3.5 py-2 text-sm font-semibold text-foreground transition-colors hover:border-brand-studio hover:text-brand-studio"
            (click)="selectMethod('template')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect width="18" height="7" x="3" y="3" rx="1" />
                <rect width="9" height="7" x="3" y="14" rx="1" />
                <rect width="5" height="7" x="16" y="14" rx="1" />
            </svg>
            Browse templates
        </button>
    </div>
    } @else if (showMethodChooser() && service.creativeMethod() === 'ai') {
    <div class="flex flex-col gap-4">
        <div class="flex gap-3.5 rounded-lg border border-brand-studio bg-brand-studio/10 p-5">
            <span class="grid size-10 shrink-0 place-items-center rounded-full bg-brand-studio text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path
                        d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                </svg>
            </span>
            <div>
                <p class="m-0 text-lg font-bold text-foreground">Let SHOUT AI draft your creative direction</p>
                <p class="m-0 mt-1 text-sm leading-relaxed text-muted-foreground">SHOUT AI uses your product and goal to
                    write the concepts, a brief overview and do's &amp; don'ts. You review and refine everything after.
                </p>
            </div>
        </div>
        <bb-field label="Anything to steer it?"
            hint="Optional — leave blank and SHOUT AI works from your brief so far.">
            <textarea [value]="aiSteer()" (input)="aiSteer.set($any($event.target).value)" rows="3"
                placeholder="Add anything to steer SHOUT AI — tone, must-mention features, references…"
                class="w-full resize-y rounded-md border border-border bg-card px-3 py-2 text-sm outline-none focus:border-brand-studio focus:ring-2 focus:ring-brand-studio/25"></textarea>
        </bb-field>
        <button type="button" (click)="draftWithAi()"
            class="inline-flex items-center gap-2 self-start rounded-md bg-brand-studio px-4 py-2.5 text-sm font-bold text-white transition-colors hover:bg-brand-studio-dark disabled:opacity-50">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path
                    d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
            </svg>
            Draft with SHOUT AI
        </button>
    </div>
    } @else {

    @if (showMethodChooser() && service.creativeTemplateApplied()) {
    <div class="flex items-center gap-3 rounded-md border border-green-500/30 bg-green-500/10 px-4 py-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="shrink-0 text-green-600 dark:text-green-400">
            <rect width="18" height="7" x="3" y="3" rx="1" />
            <rect width="9" height="7" x="3" y="14" rx="1" />
            <rect width="5" height="7" x="16" y="14" rx="1" />
        </svg>
        <p class="m-0 flex-1 text-sm text-muted-foreground"><span class="font-bold text-foreground">Template
                applied.</span> Tweak anything below before you continue.</p>
        <button type="button"
            class="inline-flex items-center gap-2 rounded-md border border-border px-3 py-1.5 text-sm font-semibold text-foreground transition-colors hover:border-brand-studio hover:text-brand-studio"
            (click)="selectMethod('template')">Change template</button>
    </div>
    }

    <bb-field label="Creative concepts" hint="The big ideas creators can run with.">
        <div class="flex flex-col gap-2.5">
            @for (concept of service.creativeConcepts(); track concept.id; let i = $index) {
            <div class="rounded-lg border border-border bg-card p-3.5">
                <div class="mb-2 flex items-center gap-2">
                    <span
                        class="rounded-full bg-brand-studio/10 px-2 py-0.5 text-[11px] font-bold text-brand-studio-dark dark:text-brand-studio">Concept
                        {{ i + 1 }}</span>
                    <span class="flex-1"></span>
                    <button type="button" aria-label="Remove concept"
                        class="grid size-8 place-items-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground"
                        (click)="removeConcept(i)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
                            <path d="M3 6h18" />
                            <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                        </svg>
                    </button>
                </div>
                <input [value]="concept.name" (input)="updateConcept(i, 'name', $any($event.target).value)"
                    placeholder="Concept name"
                    class="mb-2 w-full rounded-md border border-border bg-card px-3 py-2 text-sm font-bold outline-none focus:border-brand-studio focus:ring-2 focus:ring-brand-studio/25" />
                <textarea [value]="concept.description"
                    (input)="updateConcept(i, 'description', $any($event.target).value)" rows="2"
                    placeholder="Describe the creative idea…"
                    class="w-full resize-y rounded-md border border-border bg-card px-3 py-2 text-sm outline-none focus:border-brand-studio focus:ring-2 focus:ring-brand-studio/25"></textarea>
            </div>
            }
            <button type="button"
                class="inline-flex items-center gap-2 self-start rounded-md border border-border px-3.5 py-2 text-sm font-semibold text-foreground transition-colors hover:border-brand-studio hover:text-brand-studio"
                (click)="addConcept()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                </svg>
                Add concept
            </button>
        </div>
    </bb-field>

    <bb-field label="Brief Overview / Key Messaging"
        hint="The shot-by-shot brief creators should hit. Describe the brief context, and what you're aiming for. This is the main brief content.">
        <atom-wysiswyg #stepsWysiwyg [inputHtml]="service.stepsHtml()"
            [placeholder]="'Describe each shot or step creators should follow…'"
            (htmlContentChange)="onStepsHtmlChange($event)" />
    </bb-field>

    <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <bb-field label="Do's" [labelIconHtml]="checkIcon">
            <bb-edit-list [items]="dos()" placeholder="Add a do" addLabel="Add a do" (itemsChange)="setDos($event)" />
        </bb-field>
        <bb-field label="Don'ts" [labelIconHtml]="crossIcon">
            <bb-edit-list [items]="donts()" placeholder="Add a don't" addLabel="Add a don't"
                (itemsChange)="setDonts($event)" />
        </bb-field>
    </div>

    <bb-field label="Video pointers" hint="Links to example videos you like — creators use them as reference.">
        <bb-tag-input [tags]="service.videoPointers()" placeholder="Paste an example video link + Enter"
            (tagsChange)="service.videoPointers.set($event)" />
    </bb-field>
    }
    }

    <bb-external-brief-link-modal #externalBriefModal (useDocument)="selectMethod('upload')" />

    @if (briefAi.draftError(); as error) {
    <div role="alert"
        class="rounded-lg border border-destructive/30 bg-destructive/10 px-4 py-3 text-sm text-destructive">
        <p class="m-0">{{ error }}</p>
    </div>
    }
</div>
